import React from "react";
import { useNavigate } from "react-router-dom";

export default function DeleteAccount() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center w-full">

      {/* Back button */}
      <div className="w-full max-w-6xl px-4 pt-3">
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 text-sm"
        >
          ← Volver
        </button>
      </div>

      {/* Title */}
      <h1 className="text-lg font-semibold mt-2 mb-3 text-center w-full px-4">
        Eliminar cuenta - Realty Shot
      </h1>

      {/* Content */}
      <div className="w-full max-w-3xl px-4 text-sm text-gray-700">
        <p className="mb-3">
          Si querés eliminar tu cuenta y todos tus datos:
        </p>

        <ul className="list-disc pl-5 mb-4">
          <li>Desde la app → Mi Perfil → Eliminar cuenta</li>
          <li>O enviando un email a info@realty-shot.com</li>
        </ul>

        <p className="text-xs text-gray-500">
          Al solicitar la eliminación, borraremos toda tu información personal y
          contenido asociado. Este proceso es irreversible.
        </p>
      </div>
    </div>
  );
}